import { ISearchBar } from '../state';
import {
  HotelSearchBarActions,
  HotelSearchBarActionType,
  IHotelSearchBarState,
} from '../types/hotel';

export const hotelReducer = (
  state: ISearchBar,
  action: HotelSearchBarActions
): { hotel: IHotelSearchBarState } => {
  const { type, payload } = action;

  switch (type) {
    case HotelSearchBarActionType.SET_ALL:
      return {
        hotel: {
          ...state.hotel,
          ...payload,
        },
      };

    case HotelSearchBarActionType.SET_LOCATION:
      return {
        hotel: {
          ...state.hotel,
          location: payload,
        },
      };

    case HotelSearchBarActionType.SET_IS_LOCATION_ERROR:
      return {
        hotel: {
          ...state.hotel,
          isLocationError: payload,
        },
      };

    case HotelSearchBarActionType.SET_ROOMS:
      return {
        hotel: {
          ...state.hotel,
          rooms: payload,
        },
      };

    case HotelSearchBarActionType.SET_CHECK_DATES:
      return {
        hotel: {
          ...state.hotel,
          checkDates: payload,
        },
      };

    case HotelSearchBarActionType.SET_IS_CHECK_DATES_ERROR:
      return {
        hotel: {
          ...state.hotel,
          isCheckDatesError: payload,
        },
      };

    case HotelSearchBarActionType.SET_IS_DRAWER_OPEN:
      return {
        hotel: {
          ...state.hotel,
          isDrawerOpen: payload,
        },
      };

    case HotelSearchBarActionType.SET_IS_HOTEL_DATE_SELECTED:
      return {
        hotel: {
          ...state.hotel,
          isHotelDateSelected: payload,
        },
      };

    case HotelSearchBarActionType.SET_ALL_RESULTS_URL:
      return {
        hotel: {
          ...state.hotel,
          allResultsURL: payload,
        },
      };

    default:
      return {
        hotel: {
          ...state.hotel,
        },
      };
  }
};
